import React from 'react';
import {withDynamicComponents} from 'higher-order-components';
import PromoAndButtonModalWindow from '../../containers/promo-and-button-modal-window';
// import Wysiwyg from '../../containers/wysiwyg';

const PromoAndButtonModalWindowBlock = props => <PromoAndButtonModalWindow {...props} />;
PromoAndButtonModalWindowBlock.displayName = 'PromoAndButtonModalWindow';

export default withDynamicComponents({
  componentWhitelist: [
    // Wysiwyg,
  ],
  mapInputToOutput: [
    // ['ctaButton', 'ctaButton'],
    // ['pcContents', 'pcContents'],
    // ['mbContents', 'mbContents'],
  ],
})(PromoAndButtonModalWindowBlock);



// WEBPACK FOOTER //
// ./src/blocks/promo-and-button-modal-window/index.jsx